module.exports = __webpack_public_path__ + "static/media/Max75.80ddf647.jpg";